"use strict";

define('view/products.dropdown.view',['require','exports','module','underscore','uikit/uikit'],function (require, exports, module) {
  var _ = require('underscore'),
    UIKit = require('uikit/uikit');
  var ProductsDropdown = UIKit.Dropdown.extend({
    events: _.extend({}, UIKit.Dropdown.prototype.events, {
      "keydown": "handleProductsKeydown",
      "blur": "handleBlur"
    }),
    handleBlur: function handleBlur() {
      $(".product-switcher ul a").each(function (index, item) {
        if ($(item).hasClass("selected")) {
          $(item).removeClass("selected");
        }
        if ($(item).hasClass("active")) {
          $(item).removeClass("active");
        }
      });
    },
    handleProductsKeydown: function handleProductsKeydown(ev) {
      var items = $(".product-switcher ul a");
      var selectedItemIndex = items.index(ev.target);
      if (["Enter", " "].includes(ev.key) && $(ev.target).hasClass("product-switcher")) {
        ev.preventDefault();
        $(ev.target).get(0).click();
        var selectedItem = $(".product-switcher ul a").first();
        setTimeout(function () {
          selectedItem.addClass("selected");
          selectedItem.attr("aria-selected", "true");
          selectedItem.get(0).focus();
        }, 10);
        return;
      }
      if ([" ", "Enter"].includes(ev.key)) {
        ev.preventDefault();
        $(ev.target).get(0).click();
        return;
      }
      if (ev.key === "ArrowDown") {
        ev.preventDefault();
        $(ev.target).attr("aria-selected", "false");
        $(ev.target).removeClass("selected");
        if (selectedItemIndex === items.length - 1) {
          $(items[0]).attr("aria-selected", "true");
          $(items[0]).addClass("selected");
          items.get(0).focus();
        } else {
          $(items[selectedItemIndex + 1]).attr("aria-selected", "true");
          $(items[selectedItemIndex + 1]).addClass("selected");
          $(items[selectedItemIndex + 1]).focus();
        }
        return;
      }
      if (ev.key === "ArrowUp") {
        ev.preventDefault();
        $(ev.target).attr("aria-selected", "false");
        $(ev.target).removeClass("selected");
        if (selectedItemIndex === 0) {
          $(items[items.length - 1]).attr("aria-selected", "true");
          $(items[items.length - 1]).addClass("selected");
          $(items[items.length - 1]).focus();
        } else {
          $(items[selectedItemIndex - 1]).attr("aria-selected", "true");
          $(items[selectedItemIndex - 1]).addClass("selected");
          $(items[selectedItemIndex - 1]).focus();
        }
        return;
      }
      this.handleKeydown(ev);
    },
    updateAttributes: function updateAttributes() {
      UIKit.Dropdown.prototype.updateAttributes.apply(this, arguments);
      this.$("ul").attr("role", "menu");
    }
  });
  module.exports = ProductsDropdown;
});

